import "./OurProducts.scss";

import ArrowIcon from "../../assets/icons/arrow.svg";

import AuracleImg1 from "../../assets/images/auracle-img-1.png";
import AuracleImg2 from "../../assets/images/auracle-img-2.png";

import AgentsImg1 from "../../assets/images//agents-img-1.png";
import AgentsImg2 from "../../assets/images//agents-img-2.png";
import AgentsImg3 from "../../assets/images//agents-img-3.png";

import GridImg from "../../assets/images/Grid.svg";
import SparkleImg from "../../assets/images/sparkle.svg";

export default function OurProducts() {
	return (
		<>
			<div className="our-products" id="our-products">
				<div className="decoration our-products-light-1" />
				<div className="decoration our-products-light-2" />
				<img
					className="decoration our-products-grid-bg"
					src={GridImg}
					alt="Grid"
				/>
				<div
					className="decoration our-products-sparkle-1"
					data-aos="fade-right"
				>
					<img src={SparkleImg} alt="Sparkle" className="shake-slow-2" />
				</div>

				<div
					className="decoration our-products-sparkle-2"
					data-aos="fade-left"
				>
					<img src={SparkleImg} alt="Sparkle" className="shake-slow-3" />
				</div>

				<div className="our-products-content-wrapper content-wrapper-lg">
					<h3 className="our-products-small-title" data-aos="fade-up">
						Our Values
					</h3>
					<h2
						className="our-products-title"
						data-aos="fade-up"
						data-aos-delay="50"
					>
						Our Products And Services
					</h2>
					<p
						className="our-products-desc"
						data-aos="fade-up"
						data-aos-delay="100"
					>
						Explore our suite of AI-driven solutions designed to
						adapt and cater to your unique needs, providing
						intuitive and smart assistance across various domains.
					</p>

					<div className="product-cards">
						<div
							className="product-card-wrapper"
							data-aos="zoom-in"
						>
							<a
								className="product-card auracle"
								href="https://aur-ai.gitbook.io/aurai/oracle/auracle"
							>
								{/* background */}
								<div className="decoration gradient-bg"></div>
								<div className="decoration noise-bg"></div>

								<h4 className="product-card-title">
									<div className="product-card-title-text">
										<span className="main-title">
											Auracle
										</span>
										<span className="sub-title">
											Your Oracle to Success
										</span>
									</div>
									<img
										src={ArrowIcon}
										alt="Arrow Icon"
										className="product-card-arrow"
									/>
								</h4>

								<ul className="product-card-texts">
									<li className="product-card-text-wrapper">
										<div className="product-card-text">
											<h5 className="product-card-text-title">
												Technical Analysis
											</h5>
											<p className="product-card-text-desc">
												Provides in-depth technical
												analysis to support informed
												trading decisions
											</p>
										</div>
									</li>

									<li className="product-card-text-wrapper">
										<div className="product-card-text">
											<h5 className="product-card-text-title">
												Insights and Market Analysis
											</h5>
											<p className="product-card-text-desc">
												Delivers comprehensive market
												insights and analyses to
												identify trends and
												opportunities
											</p>
										</div>
									</li>

									<li className="product-card-text-wrapper">
										<div className="product-card-text">
											<h5 className="product-card-text-title">
												Aur API
											</h5>
											<p className="product-card-text-desc">
												Offers a robust API for seamless
												integration of our AI-driven
												insights into your platforms
											</p>
										</div>
									</li>
								</ul>

								<img
									src={AuracleImg1}
									alt="Auracle"
									className="product-card-img auracle-img-1"
								/>
								<img
									src={AuracleImg2}
									alt="Auracle"
									className="product-card-img auracle-img-2"
								/>
							</a>
						</div>

						<div
							className="product-card-wrapper"
							data-aos="zoom-in"
						>
							<a
								className="product-card agents"
								href="https://aur-ai.gitbook.io/aurai/agents/aurtrader"
								data-aos="zoom-in"
							>
								{/* background */}
								<div className="decoration gradient-bg"></div>
								<div className="decoration noise-bg"></div>

								<h4 className="product-card-title">
									Agents
									<img
										src={ArrowIcon}
										alt="Arrow Icon"
										className="product-card-arrow"
									/>
								</h4>

								<ul className="product-card-texts">
									<li className="product-card-text-wrapper">
										<div className="product-card-text">
											<h5 className="product-card-text-title">
												AurTrader
											</h5>
											<p className="product-card-text-desc">
												An AI-powered trading assistant
												designed to enhance your trading
												strategies and execution
											</p>
										</div>
									</li>
								</ul>

								<img
									src={AgentsImg1}
									alt="Agents"
									className="product-card-img agents-img-1"
								/>
								<img
									src={AgentsImg2}
									alt="Agents"
									className="product-card-img agents-img-2"
								/>
								<img
									src={AgentsImg3}
									alt="Agents"
									className="product-card-img agents-img-3"
								/>
							</a>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
